(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metabolic-trio-lp2-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.testimonialsReady === 'true') return;

      const track = root.querySelector('[data-metabolic-trio-lp2-track]');
      const slides = Array.from(root.querySelectorAll('[data-metabolic-trio-lp2-slide]'));
      const previous = root.querySelector('[data-metabolic-trio-lp2-prev]');
      const next = root.querySelector('[data-metabolic-trio-lp2-next]');
      const dots = root.querySelector('[data-metabolic-trio-lp2-dots]');

      if (!track || !slides.length || !previous || !next || !dots) return;

      root.dataset.testimonialsReady = 'true';
      let index = 0;
      let maximumIndex = 0;

      const visibleSlides = () => {
        if (window.matchMedia('(max-width: 640px)').matches) return 1;
        if (window.matchMedia('(max-width: 900px)').matches) return 2;
        return 3;
      };

      const renderDots = () => {
        dots.replaceChildren();
        for (let dotIndex = 0; dotIndex <= maximumIndex; dotIndex += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'metabolic-trio-lp2-carousel-dot';
          dot.setAttribute('aria-label', `Show testimonial ${dotIndex + 1}`);
          dot.addEventListener('click', () => {
            index = dotIndex;
            update();
          });
          dots.append(dot);
        }
      };

      const update = () => {
        index = Math.min(Math.max(index, 0), maximumIndex);
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const distance = slides[0].getBoundingClientRect().width + gap;
        track.style.transform = `translate3d(${-index * distance}px, 0, 0)`;
        previous.disabled = index === 0;
        next.disabled = index === maximumIndex;

        Array.from(dots.children).forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
        });
      };

      const refresh = () => {
        maximumIndex = Math.max(slides.length - visibleSlides(), 0);
        index = Math.min(index, maximumIndex);
        renderDots();
        update();
      };

      previous.addEventListener('click', () => {
        index -= 1;
        update();
      });

      next.addEventListener('click', () => {
        index += 1;
        update();
      });

      let resizeFrame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(refresh);
      });

      refresh();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-metabolic-trio-lp2-carousel]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
